import { render } from "./ForeignDataModal.vue?vue&type=template&id=3618bd1b"
import script from "./ForeignDataModal.vue?vue&type=script&lang=js"
export * from "./ForeignDataModal.vue?vue&type=script&lang=js"

import "./ForeignDataModal.vue?vue&type=style&index=0&id=3618bd1b&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__